import { render, staticRenderFns } from "./sceneDetail.vue?vue&type=template&id=3bf0a444&"
import script from "./sceneDetail.vue?vue&type=script&lang=js&"
export * from "./sceneDetail.vue?vue&type=script&lang=js&"
import style0 from "./sceneDetail.vue?vue&type=style&index=0&id=3bf0a444&prod&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports